import axios from "axios";
import { tipddytoken, moodleURL } from "../apirest";

const baseURL = "https://campus.colegioezer.cl/";

export const getCurrentUser = async ({ token, username, baseUrl, tipddytoken }) => {
  const resp = await axios.get(
    `${baseUrl}/webservice/rest/server.php?wstoken=${token}&wsfunction=core_user_get_users_by_field&field=username&values[0]=${username}&moodlewsrestformat=json`
  );
  if (resp.data.errorcode) {
    throw new Error(resp.data.message || resp.data.errorcode);
  }
  const user = resp.data[0];
  if (!user) {
    throw new Error("User not found");
  }

  let guardianData = null;
  try {
    const guardianResp = await axios.post(
      `${baseUrl}/webservice/rest/server.php?wstoken=${tipddytoken}&wsfunction=local_guardian_get_my_students&user[username]=${username}&moodlewsrestformat=json`
    );
    if (!guardianResp.data.errorcode) {
      guardianData = guardianResp.data;
    }
  } catch (e) {
    console.error("Error fetching guardian data:", e);
  }

  const resultUser = { ...user, token };

  if (guardianData && guardianData.viewer) {
    resultUser.guardian_type = guardianData.viewer.type;
    resultUser.is_guardian = guardianData.viewer.is_guardian || false;
    resultUser.students = guardianData.students;
    resultUser.students_count = guardianData.students_count;

    localStorage.setItem("is_guardian", guardianData.viewer.is_guardian || false);
  }

  return resultUser;
};

/* auth_userkey_request_login_url */

const login = async ({ username, password }) => {
  const respAuth = await axios.get(
    `${baseURL}login/token.php?username=${username}&password=${password}&service=moodle_mobile_app`
  );
  const data = respAuth.data;
  console.log(respAuth)
  if (data.error) {
    throw new Error(data.error);
  }
  const { token } = data;
  return { data, token };
};

export const requestAutoLogin = async ({ username, baseUrl,tipddytoken }) => {
  try {
    console.log(username, baseUrl, tipddytoken);
    const { data } = await axios.get(
      `${baseUrl}/webservice/rest/server.php?wstoken=${tipddytoken}&moodlewsrestformat=json&wsfunction=auth_userkey_tipddy_request_login_url&user[username]=${username}`
    );
    console.log({ requestAutoLogin: data, username, tipddytoken });
    console.log(data)
    let key = data && data.loginurl.split("=")[1];
    return {key,data};
  } catch (e) {
    throw new Error(e);
  }
};

/* export const requestAutoLogout = () => {
  let url = `${baseURL}auth/userkey/logout.php?return=${API.dev}`

} */

  export const loginMoodle = async (payload) => {
    let { baseUrl, credentials, tipddytoken } = payload;
    let { username, password } = credentials;
    console.log({ baseUrl });
    try {
      const { token } = await login({ username, password, baseUrl });
      const user = await getCurrentUser({ token, username, baseUrl, tipddytoken });
      // console.log({ user });
      localStorage.setItem("token", token);
      localStorage.setItem("username", username);
      return { ...user, token };
    } catch (e) {
      throw new Error(e);
    }
  };

export const resetPasword = async (args) => {
  console.log({ args });
  try {
    const { data } = await axios.post(
      "https://par.tuclase.cl/tipddy/admin/iapp/services/restore-password.php/user/changepasswordforce",
      { ...args },
      {
        headers: {
          "Content-type": "application/json",
        },
      }
    );
    return data;
  } catch (e) {
    console.log(e);
    throw new Error(e);
  }
};

export const authMiddleware = async ({ token, username }) => {
  try {
    const user = await getCurrentUser({ token, username });
    if (user.errorcode) {
      localStorage.setItem("username", username);
      localStorage.setItem("token", token);
      return user;
    }
    localStorage.setItem("token", token);
    localStorage.setItem("username", username);
    return { ...user, token };
  } catch (err) {
    console.log(err);
    throw new Error(err.message);
  }
};

export const uploadFile = async ({ token, file, baseUrl }) => {
  const formData = new FormData();
  formData.append("file", file);
  const resp = await axios.post(
    `${baseUrl}/webservice/upload.php?token=${token}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return resp.data;
};

export const updateUserPicture = async ({
  token,
  userid,
  draftitemid,
  baseUrl,
}) => {
  const resp = await axios.get(
    `${baseUrl}/webservice/rest/server.php?wstoken=${token}&wsfunction=core_user_update_picture&userid=${userid}&draftitemid=${draftitemid}&moodlewsrestformat=json`
  );
  return resp.data;
};
